import { FilterCheckboxList } from '~/Components/Filter';
import { FilterType, useSelectedMap } from '~/Hooks/useFilter';
import { useLanguage } from '~/Hooks/useLanguage';
import { useProviderFilters } from '../useProviderFilters';
import React from 'react';
import { AttendanceStatus } from '~/Models/DTO/Attendance.model';

export interface IUseLocationsGroupFilterProps {
  filterType: FilterType;
  initialFilter?: string[];
}

export const useManualBookingTypeFilter = ({
  filterType,
  initialFilter = [],
}: IUseLocationsGroupFilterProps) => {
  const { appliedFilters } = useProviderFilters({ filterType });
  const { status: initialState = initialFilter } = appliedFilters;
  const { t } = useLanguage();

  const list = [
    {
      id: 'CheckedIn',
      label: AttendanceStatus.CheckedIn,
    },
    {
      id: 'LateCancellation',
      label: AttendanceStatus.LateCancellation,
    },
    {
      id: 'NoShow',
      label: AttendanceStatus.NoShow,
    },
  ];

  const {
    selectItem,
    onClearMap,
    onApplyMap,
    selectedMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  } = useSelectedMap({ initialState });

  return {
    name: 'status',
    title: t('app.payouts.status'),
    elements: <FilterCheckboxList list={list} selectItem={selectItem} selectedMap={selectedMap} />,
    onClearMap,
    onApplyMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  };
};
